<ac-card>
  <ac-card-content>
    <div class="purchase-dialog">
      @switch (purchase().purchase_status) { @case('complete') {
      <app-purchase-dialog-header
        title="Purchase Complete"
        [hideBack]="true"
        (close)="close.emit()"
      />
      } @case('failed') {
      <app-purchase-dialog-header
        title="Purchase Failed"
        [hideBack]="true"
        (close)="close.emit()"
      />
      } @case('blocked') {
      <app-purchase-dialog-header
        title="Purchase Under Review"
        [hideBack]="true"
        (close)="close.emit()"
      />
      } @default {
      <app-purchase-dialog-header
        title="Purchase in Progress"
        [hideBack]="true"
        (close)="close.emit()"
      />
      } }
      <app-payment-status-indicator [status]="purchase().purchase_status" />

      <ul class="purchase-dialog__crypto-confirm-table ac-body-md">
        @if (purchase().purchase_status !== 'blocked') {
          <li>
            <div class="purchase-dialog__crypto-confirm-table-key">Method</div>
            <div class="purchase-dialog__crypto-confirm-table-value">
              <div>{{ purchase().payment_method_label }}</div>
            </div>
          </li>

          @if (goldAmountVM() && sweepsAmountVM()) {
            <li>
              <div class="purchase-dialog__crypto-confirm-table-key">Receive</div>
              <div class="purchase-dialog__crypto-confirm-table-value">
                <div class="ac-flex ac-gap-xs ac-ctr">
                  <app-gc-icon [size]="16" />
                  <span class="ac-title-md"><span>{{ goldAmountVM() | decimal : '0-4' }}</span> GC</span>
                  <span class="ac-flex ac-gap-xs ac-ctr" sweepsVisible>
                    <span class="ac-label ac-body-sm">Plus Free</span>
                    <app-sc-icon [size]="16" />
                    <span class="ac-title-md"><span>{{ sweepsAmountVM() | decimal : '0-4' }}</span> SC</span>
                  </span>
                </div>
              </div>
            </li>
          }

          <li>
            <div class="purchase-dialog__crypto-confirm-table-key">
              Time & Date
            </div>
            <div class="purchase-dialog__crypto-confirm-table-value">
              <div>
                {{
                  purchase().updated_at_by_provider
                    | date : 'MMMM d, yyyy • h:mm a'
                }}
              </div>
            </div>
          </li>
          <li>
            <div class="purchase-dialog__crypto-confirm-table-key">Total</div>
            <div class="purchase-dialog__crypto-confirm-table-value">
              <div>{{ amount() | currency : 'USD' : 'symbol-narrow' }} USD</div>
            </div>
          </li>
          } @else {
            <li>
              <div class="purchase-dialog__crypto-confirm-table-key">Total</div>
              <div class="purchase-dialog__crypto-confirm-table-value">
                <div>{{ amount() | currency : 'USD' : 'symbol-narrow' }} USD</div>
              </div>
            </li>
            <li>
              <div class="purchase-dialog__crypto-confirm-table-key">Status</div>
              <div class="purchase-dialog__crypto-confirm-table-value">
                <div class="purchase-dialog__pill purchase-dialog__pill--blocked">
                  Under Review
                </div>
              </div>
            </li>
            <li>
              <div class="purchase-dialog__crypto-confirm-table-key">
                Time & Date
              </div>
              <div class="purchase-dialog__crypto-confirm-table-value">
                <div>
                  {{
                    purchase().updated_at_by_provider
                      | date : 'MMMM d, yyyy • h:mm a'
                  }}
                </div>
              </div>
            </li>
          }
      </ul>

      @if (nameMismatch()) {
        <app-name-mismatch-notice (contactSupport)="close.emit('contact-support')" />
      }

      @if (purchase().purchase_status === 'blocked') {
        <div class="purchase-dialog__footer">
          <div class="purchase-dialog__footer-text ac-body-sm">
            Have a question about this?
            <a class="ac-link ac-title-sm" (click)="close.emit('contact-support')">Contact Support</a>
          </div>
        </div>
      }
    </div>
  </ac-card-content>
</ac-card>
